"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_admin_1 = require("react-admin");
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@mui/material/styles");
var userPermissions_1 = require("@/Hooks/userPermissions");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var OAuth2ClientActiveSwitchField_1 = __importDefault(require("./OAuth2ClientActiveSwitchField"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var Api_module_css_1 = __importDefault(require("./Api.module.css"));
var OAuth2ClientList = function (_a) {
    var onRowClick = _a.onRowClick, permissions = _a.permissions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var refresh = (0, react_admin_1.useRefresh)();
    var resourceType = types_1.ResourceType.OAUTH2CLIENT;
    var logger = q_play_core_1.logManager.getLogger();
    var deleteSingleClientEntry = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deleteOAuth2Client(id)];
                case 1:
                    _a.sent();
                    refresh();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error deleting OAuth2 client:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_admin_1.ListBase, { perPage: 100, resource: "oAuth2Client" },
        react_1.default.createElement("div", { className: Api_module_css_1.default["content-container"] },
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                        {
                            permission: permissions.manage,
                            children: (react_1.default.createElement(react_admin_1.Datagrid, { "data-cy": "oauth2ClientListRows", hover: false, bulkActionButtons: false, sx: RAStyles_1.RaOAuth2ClientDataGridSx, rowClick: function (id, basePath, record) {
                                    var permissionCheck = hasPermission(__spreadArray([], permissions.manage, true));
                                    if (permissionCheck) {
                                        onRowClick(record);
                                    }
                                    return false;
                                } },
                                react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), "data-cy": "oauth2ClientName" }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "client_id", label: t("Client ID") }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "client_secret", label: t("Client Secret") }),
                                react_1.default.createElement(OAuth2ClientActiveSwitchField_1.default, { source: "active", label: t("Active"), permissions: permissions }),
                                react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(AccessControl_1.default, { requiredPermissions: permissions.manage },
                                        react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () { return onRowClick(record); }, resourceId: record.id, onDelete: function () { return deleteSingleClientEntry(record.id); }, resourceType: resourceType, "data-cy": "meatballMenuIcon" }))); } })))
                        },
                        {
                            permission: __spreadArray(__spreadArray([], permissions.read, true), permissions.write, true),
                            children: (react_1.default.createElement(react_admin_1.Datagrid, { "data-cy": "oauth2ClientListRows", hover: false, bulkActionButtons: false, sx: RAStyles_1.RaOAuth2ClientDataGridSx },
                                react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), "data-cy": "oauth2ClientName" }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "client_id", label: t("Client ID") }),
                                react_1.default.createElement(react_admin_1.TextField, { source: "client_secret", label: t("Client Secret") }),
                                react_1.default.createElement(OAuth2ClientActiveSwitchField_1.default, { source: "active", label: t("Active"), permissions: permissions })))
                        }
                    ] })),
            react_1.default.createElement(Pagination_1.default, { rowsPerPageOptions: [100, 250, 500, 1000] }))));
};
exports.default = OAuth2ClientList;
